import countries from 'svg-country-flags/countries.json';

export const getDevice = () => (() => {
    if (navigator.userAgent.match(/(iPhone|iPod|Android.*Mobile)/i)) {
        // iPhone、iPod、Android(Mobileを含む)
        document.body.classList.add('mobile');
        return 'mobile';
    } else if (navigator.userAgent.match(/(iPad|(?!(Android.*Mobile)+)Android)/i)) {
        // iPad、Android(Mobileを含まない)
        document.body.classList.add('tablet');
        // <meta name="viewport" content="width=900, user-scalable=no" />
        const e = document.querySelector('#meta-viewport');
        e!.setAttribute('content', 'width=1400, user-scalable=no');
        return 'tablet';
    } else {
        // それ以外はPC
        document.body.classList.add('pc');
        return 'pc';
    }
})();

interface StringKeyObject {
    [key: string]: string;
}

const _countries = countries as StringKeyObject;

export const toCountryNameFromCountryId = (value: string) => {
    const name = _countries[value];
    if (!name) throw new Error();
    return name;
};